import { useMutation, useQuery } from "react-query";
import {
	closeReport,
	createReportReasons,
	deleteComment,
	getContentReportById,
	getContentReports,
	getCoreReportTypes,
	getReportReasons,
	updateReportReasons,
} from "../services/contentReports";

export const useGetContentReports = (payload) =>
	useQuery(["getContentReports", payload], () => getContentReports(payload));

export const useGetContentReportById = (payload) =>
	useQuery(["getContentReportById", payload], () =>
		getContentReportById(payload)
	);

export const useCloseContentReport = () =>
	useMutation("closeContentReport", (payload) => closeReport(payload));

export const useDeleteComment = () =>
	useMutation("deleteComment", (payload) => deleteComment(payload));

export const useGetReportReasons = (payload) =>
	useQuery(["getReportReasons", payload], () => getReportReasons(payload));

export const useCreateReportReasons = () =>
	useMutation("createReportReasons", (payload) => createReportReasons(payload));

export const useUpdateReportReasons = () =>
	useMutation("updateReportReasons", (payload) => updateReportReasons(payload));

export const useGetCoreReportTypes = () =>
	useQuery("getReportTypes", () => getCoreReportTypes());
